<template>
  <a-config-provider :locale="zh_CN" :getPopupContainer="getPopupContainer">
  <div class="demo-app">
    <router-view />
    <!-- <div class="map-wrapper">
      <GMap/>
    </div> -->
  </div>
  </a-config-provider>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import { useMyStore } from './store'
import GMap from '/@/components/GMap.vue'
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import moment from 'moment'
import 'moment/dist/locale/zh-cn'

moment.locale('zh-cn')

export default defineComponent({
  name: 'App',
  components: { GMap },
  data () {
    return {
      zh_CN
    }
  },
  setup () {
    const store = useMyStore()
    return {}
  },
  methods: {
    getPopupContainer (el: any, dialogContext: { getDialogWrap: () => any }) {
      if (dialogContext) {
        return dialogContext.getDialogWrap()
      } else {
        return document.body
      }
    },
  },
})
</script>
<style lang="scss" scoped>
.demo-app {
  width: 100%;
  height: 100%;

  .map-wrapper {
    height: 100%;
    width: 100%;
  }
}
</style>

<style lang="scss">
#demo-app {
  width: 100%;
  height: 100%
}
</style>
